import styled from "styled-components";

export const RootContainer = styled.div`
  height: 100vh;

  .infinite-scroll-component__outerdiv {
    height: calc(100vh - 70px);
  }

  .infinite-scroll-component {
    height: 100% !important;
    overflow-x: hidden !important;
  }
`;

export const LightText = styled.div`
  padding-top: 5px;
  font-size: 12px;
`;

export const Table = styled.div`
  width: 93%;
  margin: 24px 16px 0px 16px;
  table-layout: fixed;
  max-height: 100px;
`;

export const TableHeading = styled.div`
  display: flex;
  position: sticky;
  top: 0;
  background-color: #71207c;
  z-index: 1;
  border-radius: 5px;

  > div {
    flex: 0.5;
  }
`;

export const TableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: #f1f1f1;

  :nth-of-type(odd) {
    background-color: #e1cce0;
  }

  > div {
    flex: 0.5;
  }
`;

export const TableHeadingCell = styled.div`
  padding: 13px 24px;
  text-align: left;
  color: #fff;
  font-size: 14px;

  :first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  :last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    text-align: right;
  }
  @media screen and (max-width: 365px) {
    font-size: 12px;
  }
`;

export const TableCell = styled.div`
  display: table-cell;
  padding: 13px 24px;
  text-align: left;
  color: #000;
  font-size: 14px;
  :first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
  }
  :last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    text-align: right;
  }

  @media screen and (max-width: 365px) {
    font-size: 12px;
  }
`;

export const SpinWrapper = styled.div`
  padding-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EmptyText = styled.div`
  text-align: center;
  font-size: 13px;
`;
